import {
  PriceResponse,
  ProductResponse,
} from 'services/api/responses/responseTypes';
import type { IPrice } from '../price';
import Price from '../price';
import type { IProductAddOnsInfo } from './IProductAddOnsInfo';
import type { IProduct } from './iProduct';
import type { IProductInformation } from './iProductInformation';
import ProductAddOnsInfo from './productAddOnsInfo';

export default class Product implements IProduct {
  id: string;

  name: string;

  prices: Array<IPrice>;

  information: IProductInformation;

  isAddOn: boolean;

  addOnsInfo: IProductAddOnsInfo;

  constructor(data: ProductResponse, information: IProductInformation) {
    this.id = data.id;
    this.name = data.name;
    this.information = information;
    this.isAddOn = data.is_add_on;
    this.addOnsInfo = new ProductAddOnsInfo(data.add_ons_info);
    this.prices = data.prices.map(
      (priceData: PriceResponse) => new Price(priceData)
    );
  }
}
